import { render, staticRenderFns } from "./language-prompt-list.vue?vue&type=template&id=0ea2b83e&scoped=true"
import script from "./language-prompt-list.vue?vue&type=script&lang=ts"
export * from "./language-prompt-list.vue?vue&type=script&lang=ts"
import style0 from "./language-prompt-list.vue?vue&type=style&index=0&id=0ea2b83e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea2b83e",
  null
  
)

export default component.exports